{
  "version": 1,
  "asset_id": "4077c1a3-4602-4e16-8d84-9cf1d768bea5",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/4077c1a3-4602-4e16-8d84-9cf1d768bea5/gastric-bypass-v2-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/4077c1a3-4602-4e16-8d84-9cf1d768bea5/gastric-bypass-v2-1200.jpg",
  "original_filename": "gastric-bypass-v2-1200.jpg",
  "size": 115640,
  "content_type": "image/jpeg",
  "created_at": "2026-09-25T13:00:51Z"
}
